/**
 * Traverses the dom tree including shadow doms to find the first element that scrolls.
 */
const getScrollParent = (child) => {
    const scrollParent = (node) => {
        const parent = findParent(node);
        if (!parent) {
            return document.scrollingElement || document.documentElement;
        }
        if (canScroll(parent))
            return parent;
        return scrollParent(parent);
    };
    return scrollParent(child);
};
const findParent = (node) => {
    var _a, _b, _c, _d, _e, _f;
    return node.assignedSlot
        ? (_c = (_a = node.assignedSlot.parentElement) !== null && _a !== void 0 ? _a : (_b = node.assignedSlot.parentNode) === null || _b === void 0 ? void 0 : _b.parentElement) !== null && _c !== void 0 ? _c : node.assignedSlot.getRootNode().host
        : (_f = (_d = node.parentElement) !== null && _d !== void 0 ? _d : (_e = node.parentNode) === null || _e === void 0 ? void 0 : _e.parentElement) !== null && _f !== void 0 ? _f : node.getRootNode().host;
};
const canScroll = (node) => {
    const style = getComputedStyle(node, null);
    return (style.getPropertyValue('display') !== 'hidden' &&
        style.getPropertyValue('display') !== 'contents' &&
        (style.getPropertyValue('overflow') === 'scroll' ||
            style.getPropertyValue('overflow') === 'auto' ||
            style.getPropertyValue('overflow-y') === 'scroll' ||
            style.getPropertyValue('overflow-y') === 'auto' ||
            style.getPropertyValue('overflow-x') === 'scroll' ||
            style.getPropertyValue('overflow-x') === 'auto'));
};

export { getScrollParent };
